import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { isValidUUID } from '../../../utils/functions';

export interface IObjectiveTestInfo {
  registration_id: string;
  candidate: {
    name: string;
    cpf: string;
    date_of_birth: string;
  };
  vacancy: {
    name: string;
    id: string;
  };
  objective_test_info: {
    absent: boolean;
    age_day: number;
    age_year: number;
    age_month: number;
    eliminated: boolean;
    secret_number: string;
    chosen_questions: Record<string, string>;
    total_days_passed: number;
  };
  candidate_attachments: {
    document_name: string;
    file_url: string;
  }[];
}

const getObjectiveTestInfo = async (registration_id: string) => {
  if (!isValidUUID(registration_id)) return;

  const response = await configApi.get<IObjectiveTestInfo>(
    `results/objective-test/info/?registration_id=${registration_id}`,
  );
  return response.data;
};

export const useGetObjectiveTestInfo = (registration_id: string, enabled: boolean = false) => {
  return useQuery({
    queryKey: ['objective_test_info', registration_id],
    queryFn: () => getObjectiveTestInfo(registration_id),
    refetchOnWindowFocus: false,
    enabled,
  });
};
